import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalculateKfzComponent } from './components/calculatekfz/calculatekfz.component';
import { ErrorComponent } from './components/error/error.component';
import { CalculateRsComponent } from './components/calculaters/calculaters.component';
import { ViewpdfComponent } from './components/viewpdf/viewpdf.component';
import { CalculatehvComponent } from './components/calculatehv/calculatehv.component';
import { MaintainanceComponent } from './components/maintainance/maintainance.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'calculatekfz', pathMatch: 'full' },
  {
    path: 'calculatekfzexpert/offertantrag/:offertBaseId',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatekfzexpert/offertantrag',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatekfzexpert/fertigstellen/:offertBaseId',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true, fertigstellen: true }
  },
  {
    path: 'calculatekfzexpert/fertigstellen',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true, fertigstellen: true }
  },
  {
    path: 'calculatekfzexpert/offertbase/:offertBaseId',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatekfzexpert/offertbase',
    component: CalculateKfzComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatekfzexpert/partner/:partnerId',
    component: CalculateKfzComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatekfzexpert/partner',
    component: CalculateKfzComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatekfzexpert',
    component: CalculateKfzComponent,
    data: { expertMode: true }
  },
  {
    path: 'calculatekfz/offertbase/:offertBaseId',
    component: CalculateKfzComponent,
    data: { offertBase: true }
  },
  {
    path: 'calculatekfz/verifyoffert',
    component: CalculateKfzComponent,
    data: { verifyOffert: true }
  },
  {
    path: 'calculatekfz/resetpasscode',
    component: CalculateKfzComponent,
    data: { resetPasscode: true }
  },
  {
    path: 'calculatekfz',
    component: CalculateKfzComponent
  },
  {
    path: 'calculatemotorradexpert/offertantrag/:offertBaseId',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatemotorradexpert/offertantrag',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatemotorradexpert/offertbase/:offertBaseId',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, offertBase: true }
  },
  {
    path: 'calculatemotorradexpert/offertbase',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, offertBase: true }
  },
  {
    path: 'calculatemotorradexpert/partner/:partnerId',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, partner: true }
  },
  {
    path: 'calculatemotorradexpert/partner',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true, partner: true }
  },
  {
    path: 'calculatemotorradexpert',
    component: CalculateKfzComponent,
    data: { expertMode: true, motorrad: true }
  },
  {
    path: 'calculatemotorrad/offertbase/:offertBaseId',
    component: CalculateKfzComponent,
    data: { motorrad: true, offertBase: true }
  },
  {
    path: 'calculatemotorrad/verifyoffert',
    component: CalculateKfzComponent,
    data: { motorrad: true, verifyOffert: true }
  },
  {
    path: 'calculatemotorrad/resetpasscode',
    component: CalculateKfzComponent,
    data: { motorrad: true, resetPasscode: true }
  },
  {
    path: 'calculatemotorrad',
    component: CalculateKfzComponent,
    data: { motorrad: true }
  },
  {
    path: 'calculatersexpert/offertantrag/:offertBaseId',
    component: CalculateRsComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatersexpert/offertantrag',
    component: CalculateRsComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatersexpert/offertbase/:offertBaseId',
    component: CalculateRsComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatersexpert/offertbase',
    component: CalculateRsComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatersexpert/partner/:partnerId',
    component: CalculateRsComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatersexpert/partner',
    component: CalculateRsComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatersexpert',
    component: CalculateRsComponent,
    data: { expertMode: true }
  },
  {
    path: 'calculaters/offertbase/:offertBaseId',
    component: CalculateRsComponent,
    data: { offertBase: true }
  },
  {
    path: 'calculaters/offertbase',
    component: CalculateRsComponent,
    data: { offertBase: true }
  },
  {
    path: 'calculaters/verifyoffert',
    component: CalculateRsComponent,
    data: { verifyOffert: true }
  },
  {
    path: 'calculaters',
    component: CalculateRsComponent
  },
  {
    path: 'calculatehvexpert22/offertantrag/:offertBaseId',
    component: CalculatehvComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatehvexpert22/offertantrag',
    component: CalculatehvComponent,
    data: { expertMode: true, offertBase: true, offertAntrag: true }
  },
  {
    path: 'calculatehvexpert22/offertbase/:offertBaseId',
    component: CalculatehvComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatehvexpert22/offertbase',
    component: CalculatehvComponent,
    data: { expertMode: true, offertBase: true }
  },
  {
    path: 'calculatehvexpert22/partner/:partnerId',
    component: CalculatehvComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatehvexpert22/partner',
    component: CalculatehvComponent,
    data: { expertMode: true, partner: true }
  },
  {
    path: 'calculatehvexpert22',
    component: CalculatehvComponent,
    data: { expertMode: true }
  },
  {
    path: 'calculatehv22/offertbase/:offertBaseId',
    component: CalculatehvComponent,
    data: { offertBase: true }
  },
  {
    path: 'calculatehv22/verifyoffert',
    component: CalculatehvComponent,
    data: { verifyOffert: true }
  },
  {
    path: 'calculatehv22/resetpasscode',
    component: CalculatehvComponent,
    data: { resetPasscode: true }
  },
  {
    path: 'calculatehv22/offertbase',
    component: CalculatehvComponent,
    data: { offertBase: true }
  },
  {
    path: 'calculatehv22',
    component: CalculatehvComponent
  },
  {
    path: 'viewpdf/:url',
    component: ViewpdfComponent
  },
  {
    path: 'maintenance',
    component: MaintainanceComponent
  },
  { path: '**', component: ErrorComponent }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes);
